import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { String, Ui, Subtitle } from "@silvertours/front-shared";
import { Runtime } from "@silvertours/front-entities";
import { Container, ImageWrapper, PricePrefixTextWrapper, ProviderName, ProviderOffer, ProviderOffersList, SearchButton, SubtitleWrapper } from "./OfferBox.styles";
var OfferBox = function(param) {
    var category = param.category, image = param.image, offers = param.offers, _translations = param.translations, pricePrefix = _translations.pricePrefix, priceSuffix = _translations.priceSuffix, searchButtonText = _translations.searchButtonText, onClick = param.onClick;
    var language = Runtime.useLocale().language;
    var baseImageUrl = Runtime.useHost().baseImageUrl;
    var ref = _sliced_to_array(React.useState(false), 2), loading = ref[0], setLoading = ref[1];
    var handleClick = function() {
        if (onClick && !loading) {
            setLoading(true);
            onClick();
        }
    };
    return /*#__PURE__*/ _jsxs(Container, {
        onClick: handleClick,
        hasAction: !!onClick,
        children: [
            /*#__PURE__*/ _jsx(ImageWrapper, {
                children: /*#__PURE__*/ _jsx(Ui.Image, {
                    src: "".concat(baseImageUrl).concat(image),
                    alt: "",
                    layout: "fill",
                    objectFit: "contain"
                })
            }),
            /*#__PURE__*/ _jsx(SubtitleWrapper, {
                as: "h3",
                children: category
            }),
            /*#__PURE__*/ _jsx(ProviderOffersList, {
                children: offers.map(function(param) {
                    var supplier = param.supplier, price = param.price, currency = param.currency;
                    return /*#__PURE__*/ _jsxs(ProviderOffer, {
                        children: [
                            /*#__PURE__*/ _jsx(ProviderName, {
                                inline: true,
                                children: supplier
                            }),
                            /*#__PURE__*/ _jsxs(PricePrefixTextWrapper, {
                                inline: true,
                                textColor: "grey",
                                children: [
                                    pricePrefix,
                                    /*#__PURE__*/ _jsx(Subtitle, {
                                        as: "span",
                                        textColor: "orange",
                                        children: String.formatPrice(price, currency, language, {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    priceSuffix
                                ]
                            })
                        ]
                    }, supplier);
                })
            }),
            onClick && /*#__PURE__*/ _jsx(SearchButton, {
                variant: "primary",
                onClick: handleClick,
                fullWidth: true,
                children: searchButtonText
            })
        ]
    });
};
export { OfferBox };
